import {WhatIfScenarioConfig, WhatIfScenarioInputValues, WhatIfScenarioRecord} from "../../ps-types";
import {Container, Grid} from "semantic-ui-react";
import {LocatorsMapInput} from "./LocatorsMapInput";
import { LoadfromDataSourceBtn } from "./LoadFromDataSourceBtn";

export function GlobalInputs({config, inputData, updateInputData}: {
  config: WhatIfScenarioConfig,
  inputData: WhatIfScenarioRecord['inputData'],
  updateInputData: (scenario: WhatIfScenarioRecord['inputData']) => void,
}) {

  const globalInputs = inputData.globalInputs!;

  const handleOnValuesUpdated = (values: WhatIfScenarioInputValues) => {
    let updatedGlobalInputs: WhatIfScenarioInputValues = {...(inputData?.globalInputs ?? {}), ...values};
    updateInputData({...inputData, globalInputs: updatedGlobalInputs});
  }

  return <Container>
    <div style={{marginBottom: "20px", position: "relative"}}>
      <h2>Global Inputs</h2>
      <LoadfromDataSourceBtn variant="global-inputs" projectVersions={inputData.projectVersions} config={config} onDataLoaded={(updatedGlobalInputs) => {
        handleOnValuesUpdated(updatedGlobalInputs);
      }} />
    </div>
    <Grid>{config && <LocatorsMapInput
        inputValues={globalInputs}
        mappingConfig={config.mappingConfig}
        onValuesUpdated={handleOnValuesUpdated}
    />}
    </Grid>
  </Container>
}